import { Button,  Modal,  Table} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner, faFilePdf, faCopy, faPen} from "@fortawesome/free-solid-svg-icons";
import React, {useEffect, useState} from "react";
import {useAuth} from "../../providers/authprovider";
import {useNavigate} from "react-router-dom";
import useAlert from "../../components/CustomAlert";


export default function ProtocolsModal(props){

    const {event, show, onHide} = props;
    const {showAlert, alert} = useAlert();
    const {protocols:{create, get, download}, viewPdf} = useAuth();
    const [protocols, setProtocols] = useState(undefined);
    const [downloading, setDownloading] = useState([]);
    const navigate = useNavigate();

    useEffect(()=>{
        if(protocols !== undefined)
            return;

        get(({success, error, content})=>{
            if(success === true)
                return setProtocols(content);

            showAlert(error);
        }, event.building_id)
    });

    const isDownloading = (protocolId)=>{
        return downloading.includes(protocolId);
    }

    const finishDownloading = (protocolId)=>{
        setDownloading(prevState => {
            const index = prevState.indexOf(protocolId);

            if(index > -1)
                prevState.splice(index,1);

            return [...prevState]
        })
    }

    const createEventProtocol = ()=>{
            //navigate to create protocol
        navigate('/protocols/create/');
        // create(event.id, ({success, error, content})=>{
        //     if(success === true){
        //         return navigate('/protocols/create/'+content.id);
        //     }
        //     window.alert(error);
        // })
    }

    const handleDownloadPdf = (protocolId)=>{
        setDownloading([...downloading, protocolId])
        download(protocolId, ({success,error, content})=>{
            finishDownloading(protocolId)
            if(success)
                return viewPdf(content);

            showAlert(error)
        })
    }

    const navigateToProtocolCopy = (protocolId)=>{
        navigate(`/protocols/copy/${protocolId}`)
    }

    const navigateToProtocolEdit = (protocolId)=>{
        onHide();
        navigate(`/protocols/create/${protocolId}`)
    }

    const getProtocolNamePL = (protocol)=>{
        const  {type, arrival_purpose} = protocol;
        if(arrival_purpose)
            return arrival_purpose;

        if(type === 'default')
            return "Zgłoszenie";
        else if(type === 'inspection')
            return "Przegląd"
        else
            return ""
    }


    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Protokoły
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    alert()
                }
            <Table bordered >
                <thead>
                    <tr>
                        <th>L.p.</th>
                        <th>Cel przyjazdu</th>
                        <th>Wykonał</th>
                        <th>Data protokołu</th>
                        <th>Kopia</th>
                        <th>Podgląd</th>
                        <th>Edycja</th>
                    </tr>
                </thead>
                <tbody>
                {
                    protocols?.map((protocol, i)=>{
                        return <tr key={protocol.id}>
                            <td>{i+1}</td>
                            <td>{getProtocolNamePL(protocol)}</td>
                            <td>{protocol.userName}</td>
                            <td>{new Date(protocol.date).toLocaleDateString()}</td>
                            <td><Button variant={"outline-secondary"} title={"Kopiuj protokół"} onClick={()=>navigateToProtocolCopy(protocol.id)}><FontAwesomeIcon icon={faCopy}/></Button></td>
                            <td>
                                {
                                    isDownloading(protocol.id) ?
                                        <Button variant={"outline-secondary"} title={"Podgląd"} ><FontAwesomeIcon spin={true} icon={faSpinner} /></Button>
                                        :
                                        <Button variant={"outline-secondary"} title={"Podgląd"} onClick={()=>handleDownloadPdf(protocol.id)} ><FontAwesomeIcon icon={faFilePdf} /></Button>
                                }

                            </td>
                            <td><Button variant={"outline-secondary"} title={"Edytuj protokół"} onClick={()=>navigateToProtocolEdit(protocol.id)}><FontAwesomeIcon icon={faPen}/></Button></td>
                        </tr>
                    })
                }
                <tr>
                    <td colSpan={6}><Button onClick={createEventProtocol} >Nowy protokół</Button></td>
                </tr>
                </tbody>
            </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide}>Zamknij</Button>
            </Modal.Footer>
        </Modal>
    )
}